import { render, staticRenderFns } from "./PhieuDangNamVienDetail.vue?vue&type=template&id=65971bfb&scoped=true"
import script from "./PhieuDangNamVienDetail.vue?vue&type=script&lang=js"
export * from "./PhieuDangNamVienDetail.vue?vue&type=script&lang=js"
import style0 from "./PhieuDangNamVienDetail.vue?vue&type=style&index=0&id=65971bfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65971bfb",
  null
  
)

export default component.exports